import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]

import { PrimaryButtonProps } from "@/views/blocks/cta/shared/primary-button/PrimaryButtonProps";


export default /*@__PURE__*/_defineComponent({
  __name: 'PrimaryButton',
  props: {
    href: {},
    label: {},
    textColor: {},
    backgroundColor: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "f295fe82": (_ctx.backgroundColor),
  "57f86fa0": (_ctx.textColor)
}))



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    href: _ctx.href,
    class: "lg:block px-4 py-2.5 rounded-lg text-sm xl:text-base"
  }, _toDisplayString(_ctx.label), 9, _hoisted_1))
}
}

})